<template>
  <div>
    <div class="d-flex flex-column">
      <div class="d-flex justify-content-between align-items-center">
        <h4 class="mb-0 ml-2" style="font-size: 16px">Assigned Personnel</h4>
        <a
          href="#"
          v-if="hasCurrentUserPermissionAccess('patients', 'create')"
          style="font-size: 14px"
          @click.prevent="$emit('onEdit', 6)"
        >
          Edit
        </a>
      </div>
      <div class="d-flex flex-column border-top p-2 mt-2">
        <div
          v-for="caseLoad in caseLoads"
          :key="caseLoad.id"
          class="mt-2"
          style="font-size: 14px;"
        >
          <strong>{{ caseLoad.caseRole.name }}: </strong>
          <span>{{ caseLoad.user | formatClient }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import caseLoadServer from "../../server/caseLoadRecord";

export default {
  name: "EocViewSummaryAssignedPersonnel",
  props: ["eoc", "showing", "refresh"],
  data() {
    return {
      caseLoads: []
    };
  },
  mounted() {
    this.fetchCaseLoads();
  },
  methods: {
    async fetchCaseLoads() {
      this.caseLoads = await caseLoadServer.getByEoc(this.eoc.id);
      this.$emit("shouldDisplay", !!this.caseLoads.length);
    }
  },
  computed: {
    ...mapGetters("layout", ["hasCurrentUserPermissionAccess"])
  },
  watch: {
    showing(newValue) {
      if (newValue) {
        this.fetchCaseLoads();
      }
    },
    refresh() {
      this.fetchCaseLoads();
    }
  }
};
</script>

<style></style>
